
export default {
  name: 'Skeleton',

  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    children: {
      type: Array,
      default: () => [],
    },
  },

  mounted() {
    document.documentElement.style.setProperty('--mobile', this.columns[0]);
    document.documentElement.style.setProperty('--tablet', this.columns[1]);
    document.documentElement.style.setProperty('--desktop', this.columns[2]);
  },

  methods: {
    rows(i) {
      return `grid-row: span ${this.children[i]}`;
    },
  },
};
